// Ubicación en el repo: src/components/CatalogTrash.jsx
// Papelera de Catálogo (auditoría técnica 11-sep-2026, hallazgo #2,
// DECISIONS.md #120) — sub-pestaña nueva de Catalog.jsx. A diferencia de
// Pacientes/Sucursales/Marcas/Categorías/Proveedores/Profesionales, un
// producto eliminado desde "Productos" no tenía forma de recuperarse sin
// entrar directo a la base de datos. Mismo patrón simple que
// BrandsList/CategoriesList/SuppliersList (restaurar directo, sin el flujo
// de "forzar eliminación con motivo" que sí necesita Pacientes por su
// historial clínico asociado — acá no aplica).
import { useCallback, useEffect, useState } from 'react';
import { listDeletedCatalogItems, restoreCatalogItem } from '../lib/catalog';
import { formatDateTime } from '../lib/format';
import Spinner from './Spinner';

export default function CatalogTrash() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setItems(await listDeletedCatalogItems());
    } catch (err) {
      setError(err.message || 'No se pudo cargar la papelera.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  async function handleRestore(item) {
    const label = `${item.brand_ref?.name || item.brand || ''} ${item.model || ''}`.trim() || 'este producto';
    const ok = window.confirm(`¿Restaurar "${label}"?`);
    if (!ok) return;
    try {
      await restoreCatalogItem(item.id);
      refresh();
    } catch (err) {
      setError(err.message || 'No se pudo restaurar el producto.');
    }
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Papelera de Catálogo</h2>
      <p className="field-hint" style={{ marginBottom: 16 }}>
        Productos eliminados desde "Productos". Restaurar los devuelve a la lista normal, con sus datos y
        precio tal como estaban.
      </p>

      {error && <p className="auth-error">{error}</p>}

      <table className="patients-table">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Categoría</th>
            <th>Eliminado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={4}>
                <Spinner inline />
              </td>
            </tr>
          ) : items.length === 0 ? (
            <tr>
              <td colSpan={4}>La papelera está vacía.</td>
            </tr>
          ) : (
            items.map((item) => (
              <tr key={item.id}>
                <td>
                  {item.brand_ref?.name || item.brand} {item.model}
                  {item.sku && <span className="text-muted"> · {item.sku}</span>}
                </td>
                <td>{item.category?.name || item.type || '—'}</td>
                <td>{formatDateTime(item.deleted_at)}</td>
                <td className="actions-cell">
                  <button type="button" className="link-button" onClick={() => handleRestore(item)}>
                    Restaurar
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
